import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../state';

import GeneralActivityReportForm from './GeneralActivityReportForm';

const FormContainer = props => (
  <Provider store={store}>
    <GeneralActivityReportForm {...props} />
  </Provider>
);

export default FormContainer;
